import { useTranslation } from "react-i18next";
import { VStack } from "../../../../../styled-system/jsx";
import { css } from "../../../../../styled-system/css";
import { useUserOrgPermissions } from "../../../../modules/admin/api/useUserOrgPermissions";
import Loading from "../../../../components/core/blocks/Loading";
import { PageContainer } from "../../../../components/core/basic/PageContainer";
import { createFileRoute } from "@tanstack/react-router";
import { Accordion } from "../../../../components/core/basic/Accordion";
import moment from "moment";
import UnauthorizedWarning from "../../../../components/core/basic/UnauthorizedWarning";
import UserPermissionsSection from "../../../../modules/user_management/components/UserPermissionsSection";
import { useDateFormatter } from "../../../../i18n/useDateFormatter";

const UserDetailsPage = () => {
  const { t } = useTranslation(["user_management"]);
  const fmt = useDateFormatter("long");
  const { id: userId } = Route.useParams();
  const userPermissionsQuery = useUserOrgPermissions(parseInt(userId), { enabled: !!userId });

  const {
    first_name: firstName,
    last_name: lastName,
    email: emailAddress,
    last_login: lastLogin,
    date_joined: dateJoined,
  } = userPermissionsQuery.data?.user_profile ?? {};

  if (!userId) {
    return <UnauthorizedWarning />;
  }

  return (
    <PageContainer>
      <VStack
        gap="medium"
        alignItems={"stretch"}
        alignSelf={"center"}
        width={"100%"}
        maxWidth={"1200px"}
        paddingY="large"
        paddingX={{ base: "medium", md: "xxlarge" }}
      >
        {userPermissionsQuery.isLoading ?
          <Loading fullPage={true} />
        : <>
            <h1 className={css({ fontSize: "xxlarge", fontWeight: 600 })}>
              {firstName} {lastName}
            </h1>
            <VStack css={{ alignItems: "start", fontSize: "medium" }}>
              <span>{t(($) => $.user_management["Email: {emailAddress}"], { emailAddress: emailAddress ?? "" })}</span>
              <span>
                {t(($) => $.user_management["Date Joined: {date}"], {
                  date: fmt.format(moment(dateJoined).toDate()),
                })}
              </span>
              <span>
                {t(($) => $.user_management["Last Login: {date}"], { date: fmt.format(moment(lastLogin).toDate()) })}
              </span>
            </VStack>
            <Accordion title={t(($) => $.user_management.Permissions)} defaultExpanded>
              <UserPermissionsSection userId={userId} persistKey={"userDetailsPagePermissionsTable"} />
            </Accordion>
          </>
        }
      </VStack>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/userdetails/$id")({
  component: UserDetailsPage,
  staticData: { application: "Admin" },
});
